import { useTranslation } from 'react-i18next'
import { breakpoints } from '@/styles'
import { Wrapper } from '@/features/Application/elements'
import { SectionTitle } from '@/features/Application/elements'
import useMediaQuery from '@/hooks/use-media-query'
import DesktopComponent from './desktop'
import MobileComponent from './mobile'

const DocumentsView = ({ application, isLocked, applicationLoading }) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const title = t('l.application.view.Application Documents.label', 'Application Documents')
  const isLoading = !!application?.trust_score?.loading
  return (
    <Wrapper>
      <SectionTitle title={title} />
      {isMobile ? (
        <MobileComponent
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          applicationLoading={applicationLoading}
        />
      ) : (
        <DesktopComponent
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          applicationLoading={applicationLoading}
        />
      )}
    </Wrapper>
  )
}

export default DocumentsView
